import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { URL, ADMIN, ADMIN_PREFIX } from "../../../lib/lib.js";
import { useAdminAuth } from "../../context/AuthContext";
import "./component.css";

const Component = () => {

  const navigate = useNavigate();
  const { setAuth } = useAdminAuth(); 
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordShown(!passwordShown);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    try {

      const response = await fetch(URL + ADMIN.login, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
        credentials: "include"
      });

      const data = await response.json();

      if(!response.ok){ 
        alert(data.message);
        return;
      }

      if (response.status === 200) {
        console.log('====================================');
        console.log(data);
        console.log('====================================');
        setAuth({
          isLoggedIn: true,
          user: data.name, // user data returned from the API
          loading: false
        });
        navigate(`${ADMIN_PREFIX}/dashboard`)
      }

    } catch (error) {

      console.error("Login error:", error);
      alert("Something went wrong. Please try again later.");
    }
  };

  return (
    <div className="login-frm" style={{ background: "rgba(216, 211, 211, 0.22)" }} >
      <div className="wrapper">
        
        <div className="title-text">
          <div className="title login">Admin Login</div>
        </div>

        <div className="form-container">
          <div className="form-inner">

            <form className="login" onSubmit={handleLogin}>

              <div className="field">
                <input type="text" placeholder="Email Address" name="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
            
              <div className="field password-field">
                <input type={passwordShown ? "text" : "password"} placeholder="Password" name="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                <span onClick={togglePasswordVisibility} className="eye-icon"> <FontAwesomeIcon icon={passwordShown ? faEyeSlash : faEye} /> </span>
              </div>
            
              <div className="field">
                <input type="submit" value="Login" />
              </div>

            </form>

          </div>
        </div>
        
      </div>
    </div>
  );
};

export default Component;
